import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function formatDate(date: Date, format: string = 'MM/DD/YYYY'): string {
  if (!date) return '';
  return dayjs(date).utc(true).format(format);
}
